import { BrowserRouter as Router } from 'react-router-dom'
import AppRoutes from 'navigation/routes'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import initFirebase from 'firebaseConfig'
import ToastProvider from 'services/context/toast'
import { CssBaseline } from '@mui/material'
import { createAppTheme } from 'styles/theme'
import { ThemeProvider } from '@mui/material/styles'
import { Provider } from 'react-redux'
import { store } from 'reduxStore/store'
import { ThemeModeProvider, useThemeMode } from 'services/context/themeMode'

/**
 * ThemedApp wraps the application with the MUI ThemeProvider
 * using the current mode from ThemeModeContext.
 */
const ThemedApp = () => {
  const { mode } = useThemeMode()

  return (
    <ThemeProvider theme={createAppTheme(mode)}>
      <CssBaseline />
      <ToastProvider>
        <Provider store={store}>
          <Router>
            <AppRoutes />
          </Router>
        </Provider>
      </ToastProvider>
    </ThemeProvider>
  )
}

/**
 * Main application component
 * @returns JSX.Element
 */
const App = () => {
  // Initialize Firebase configuration
  initFirebase()

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='pt-br'>
      <ThemeModeProvider>
        <ThemedApp />
      </ThemeModeProvider>
    </LocalizationProvider>
  )
}

export default App
